import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { API_URL } from "../../Services/ApiService"; 
import { 
  showErrorAlert,
  showSuccessAlert,
} from "../../Helper/SweetAlert";
import video from "../../assets/img/video.mp4";
export default function ForgetPassword() {
  let navigate = useNavigate();

  const [error, setError] = useState(false);
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState(false);

  const [submitLoader, setsubmitLoader] = useState(false);

  const changeEmail = (e) => {
    if (!e.includes("@")) {
      setEmailError(true);
    } else {
      setEmailError(false);
    }
    return setEmail(e);
  };

  const submitForm = async (e) => {
    e.preventDefault();
    if (!email) {
      setError(true);
      return;
    }
    setsubmitLoader(true);
    await axios.post(API_URL.Forget_Password, { email: email }).then(
      (res) => {
        console.log(res);
        if (res?.data?.status === true) {
          showSuccessAlert(res?.data?.message, ()=>{
            navigate("/login");
          }); 
        } else {
          showErrorAlert(res.data?.message); 
        }
        setsubmitLoader(false);
        setError(false);
      },
      (err) => {
        // console.log(err?.response?.data);
        setsubmitLoader(false);
        setError(false);
        showErrorAlert(err?.response?.data?.message); 
      }
    );
  };

  return (
    <>
      <div className="container-fluid page-body-wrapper full-page-wrapper">
        <div className="content-wrapper d-flex align-items-center auth px-0">
        <div className="background-video">
            <video autoPlay loop muted>
              <source src={video} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
          <div className="row w-100 mx-0">
            <div className="col-lg-4 mx-auto">
              <div
                className="auth-form-light text-center py-5 px-4 px-sm-5"
                style={{ borderRadius: "25px" }}
              >
                <div className="brand-logo">
                  <img src="../../images/logo.png" alt="logo" />
                </div>
                <h4>Please Enter Your Email</h4>
                <form
                  className="pt-3"
                  onSubmit={(e) => {
                    submitForm(e);
                  }}
                >
                  <div>
                    <div className="form-group">
                      <input
                        type="email"
                        className="form-control form-control-lg"
                        id="exampleInputEmail1"
                        placeholder="Email"
                        value={email}
                        onChange={(e) => changeEmail(e.target.value)}
                      />
                      {!email && error && (
                        <div className="error">Email is required</div>
                      )}
                      {emailError && email && (
                        <div className="error">Invalid Email Format</div>
                      )}
                    </div>
                  </div>

                  <div className="mt-3"> 
                    <button
                      type="submit"
                      className="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn"
                      disabled={submitLoader}
                    >
                      {submitLoader ? (
                        <i className="fas fa-spinner fa-spin"></i>
                      ) : (
                        "SEND"
                      )}
                    </button>

                    {/* <a
                      className="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn"
                      href="../../index.html"
                      >
                      SIGN IN
                    </a> */}
                  </div>
                  <div className="text-left mt-3">
                    <Link to={'/login'} >Bank to Login</Link>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
